import { forwardRef } from 'react';
import { Typography } from '../typography';
import { Props } from './types';
import css from './style.module.css';

export const Layout = forwardRef<HTMLElement, Props>(function Component(
  { normalize = true, inline = false, ...props },
  forwardedRef
) {
  return (
    <Typography
      {...props}
      baseClassName={css.root}
      normalize={normalize}
      inline={inline}
      ref={forwardedRef}
    />
  );
});
